<template>
  <div id="detail">
    <header>
      <img src="@/static/images/other/frozen.png" alt="" class="chenggong" />
      <p class="big-title">很抱歉，您的账号已被冻结!</p>
      <p class="tip">
        提示：请联系平台管理员进行解冻。
      </p>
    </header>

  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
#detail {
  padding-top: 82px;
  padding-bottom: 50px;
  header {
      padding-top: 80px;
    text-align: center;
    .chenggong {
      width: 189px;
      height: 158px;
    }
    .big-title {
        padding-top: 40px;
      font-family: PingFang-SC-Heavy;
      font-size: 30px;
      line-height: 36px;
      color: #66906a;
      padding-bottom: 20px;
      font-weight: bold;
    }
    .tip {
        
      font-family: PingFang-SC-Medium;
      font-size: 24px;
      line-height: 35px;
      color: #878787;
    }
  }
  .result {
    padding-top: 68px;
    padding-bottom: 73px;
    table {
      margin: 0 auto;
      width: 626px;
      height: 203px;
      background-color: #ffffff;
      border: solid 1px #1fbe6e;
      text-align: center;
      .head {
        font-family: PingFang-SC-Medium;
        font-size: 24px;
        color: #067e42;
      }
      td {
        height: 66px;
      }
    }
    .code {
      font-family: PingFang-SC-Bold;
      font-size: 34px;
      font-weight: bold;
      text-align: center;
    }
  }
  .btn {
    margin: 150px auto 0;
    width: 611px;
    .mint-button--default {
      margin-top: 40px;
    }
  }
}
</style>
